const digest = '74c54981804a500448535949447e5a4d3ce314af7970b880d3b95b0d7b995e00';
const css = `@media screen and (max-width:767px){h2._heading_aevdy_2{font-size:1.25rem;font-weight:400;line-height:1.75rem}}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'heading': '_heading_aevdy_2' };
export const heading = '_heading_aevdy_2';
export { css, digest };